import {
  RemoveItemFromCartLiteDocument,
  RemoveItemFromCartLiteMutation,
  RemoveItemFromCartLiteMutationVariables,
} from '../../../graphql/magento'
import { UseCartMutation, useCartMutation } from './useCartMutation'

export type UseCartRemoveProduct = [
  removeProductFromCart: CartMutation['0'],
  result: CartMutation['1'],
]

type CartMutation = UseCartMutation<
  RemoveItemFromCartLiteMutation,
  RemoveItemFromCartLiteMutationVariables
>

export const useCartRemoveProduct = (): UseCartRemoveProduct => {
  return useCartMutation(RemoveItemFromCartLiteDocument)
}
